import { Body, Box, Button, H4 } from '../'
import { Dialog } from './'

export const FinishQuestionDialog = ({ onContinue, onClose, ...props }) => (
  <Dialog {...props} onClose={onClose} mobileDrawer={false} mobileBackground="white">
    <H4 color="black">Are you sure?</H4>
    <Box column gap={32} fullWidth>
      <Body color="black" align="center">Not all participants have locked in their answer.</Body>
      <Box justifyContent="space-between" fullWidth>
        <Button light onClick={onClose}>Cancel</Button>
        <Button onClick={onContinue}>Continue</Button>
      </Box>
    </Box>
  </Dialog>
)